import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { AccountSelectors, AuthorizationActions, AuthorizationSelectors, ModulesSelectors } from '@serviceos-ng/core';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'serviceos-web-authentication-modal',
    templateUrl: './authentication-modal.component.html',
    styleUrls: ['./authentication-modal.component.scss'],
})
export class AuthenticationModalComponent implements OnInit {

    public screen = 'login';

    constructor(
        private store: Store
    ) {
        this.store.dispatch(new AuthorizationActions.GetSocialProviders())
    }

    ngOnInit(): void {

    }

    public onChangeScreen(screen) {
        this.screen = screen ? screen : 'login';
    }
}
